/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import {
  RequestCreateData,
  RequestQueryData,
  RequestUpdateData,
} from "../../core/models/Request";
import NetworkServiceFactory from "../../core/services/network/NetworkService";
import { DEFAULT_QUERY_DATA } from "../../core/services/network/NetworkTypes";
import { useRequestsContext } from "./RequestsContext";

const useRequestsActions = () => {
  const {
    setRequestsResponseData,
    setRequestLoading,
    setSelectedRequest,
    setRequestsError,
    requestsResponseData,
  } = useRequestsContext();

  const dispatchGetRequests = async (
    query: RequestQueryData = DEFAULT_QUERY_DATA()
  ) => {
    const networkService = NetworkServiceFactory.shared;
    try {
      const data = await networkService.getRequests(query);
      setRequestsResponseData(data);
      setRequestsError(undefined);
      return data;
    } catch (e: any) {
      setRequestsError(e);
    } finally {
      setRequestLoading(false);
    }
  };

  const dispatchGetRequest = (RequestId: string) => {
    const networkService = NetworkServiceFactory.shared;
    networkService
      .getRequestById(RequestId)
      .then((request) => {
        setSelectedRequest(request);
        setRequestsError(undefined);
      })
      .catch((e) => {
        setRequestsError(e);
      });
  };

  const dispatchCreateRequest = (query: RequestCreateData) => {
    const asyncCall = async () => {
      try {
        const data = await NetworkServiceFactory.shared.postRequest(query);
        try {
          if (requestsResponseData) {
            const data =
              await NetworkServiceFactory.shared.getRequests(
                requestsResponseData
              );
            setRequestsResponseData(data);
          }
        } catch (e) {
          // Pass
        }
        setSelectedRequest(data);
        setRequestsError(undefined);
      } catch (e: any) {
        setRequestsError(e);
      }
    };
    asyncCall().catch();
  };

  const dispatchUpdateRequest = (query: RequestUpdateData) => {
    const asyncCall = async () => {
      try {
        const data = await NetworkServiceFactory.shared.patchRequest(query);
        try {
          if (requestsResponseData) {
            const data =
              await NetworkServiceFactory.shared.getRequests(
                requestsResponseData
              );
            setRequestsResponseData(data);
          }
        } catch (e) {
          // Pass
        }
        setSelectedRequest(data);
        setRequestsError(undefined);
      } catch (e: any) {
        setRequestsError(e);
      }
    };
    asyncCall().catch();
  };

  const dispatchCleanRequestsContext = () => {
    setRequestsResponseData(undefined);
    setRequestsError();
    setSelectedRequest();
  };

  return {
    dispatchGetRequests,
    dispatchGetRequest,
    dispatchCleanRequestsContext,
    dispatchCreateRequest,
    dispatchUpdateRequest,
  };
};

export { useRequestsActions };
